import { oauthTokenSelector } from 'selectors/app'
import { FETCH_ORDERS_REQUEST } from 'ducks/integrations/recharge/types'
import { doSdkRequest } from 'ducks/requests/operations'

import * as api from '../api'

const doFetchOrders = ({ integrationId, subscriptionId }) => {
  return doSdkRequest(
    FETCH_ORDERS_REQUEST,
    async ({ getState }) => {
      const state = getState()
      const token = oauthTokenSelector(state)

      const { response } = await api.getOrders(
        token,
        integrationId,
        subscriptionId
      )
      return response
    },
    { integrationId, subscriptionId }
  )
}

export default doFetchOrders
